<script>
import { mapGetters } from 'vuex';
import { useBranding } from 'shared/composables/useBranding';
import SignupForm from './components/Signup/Form.vue';
import Testimonials from './components/Testimonials/Index.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    SignupForm,
    Spinner,
    Testimonials,
  },
  setup() {
    const { replaceInstallationName } = useBranding();
    return { replaceInstallationName };
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    isAWhiteBoardChatInstance() {
      return this.globalConfig.installationName === 'WhiteBoardChat';
    },
  },
  beforeMount() {
    this.isLoading = this.isAWhiteBoardChatInstance;
  },
  methods: {
    resizeContainers() {
      this.isLoading = false;
    },
  },
};
</script>

<template>
  <div class="w-full h-full bg-n-background">
    <div v-show="!isLoading" class="flex h-full min-h-screen items-center">
      <div
        class="flex-1 min-h-[640px] inline-flex items-center h-full justify-center overflow-auto py-6"
      >
        <div class="px-8 max-w-[560px] w-full overflow-auto">
          <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 100" class="h-12 w-auto block dark:hidden">
              <defs>
                <linearGradient id="wbcGradFullSignup" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#2563eb" />
                  <stop offset="100%" stop-color="#1d4ed8" />
                </linearGradient>
              </defs>
              <rect x="10" y="10" width="80" height="80" rx="20" fill="url(#wbcGradFullSignup)"/>
              <path d="M 31 32 H 69 C 72 32 75 35 75 38 V 58 C 75 61 72 64 69 64 H 44 L 33 72 V 64 H 31 C 28 64 25 61 25 58 V 38 C 25 35 28 32 31 32 Z" fill="#ffffff"/>
              <path d="M 35 42 L 44 58 L 50 48 L 56 58 L 65 42" stroke="#2563eb" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <text x="108" y="62" font-family="system-ui, -apple-system, sans-serif" font-weight="800" font-size="34" fill="#0f172a" letter-spacing="-0.5">WhiteBoard<tspan fill="#2563eb">Chat</tspan></text>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 100" class="h-12 w-auto hidden dark:block">
              <defs>
                <linearGradient id="wbcGradDarkSignup" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#3b82f6" />
                  <stop offset="100%" stop-color="#2563eb" />
                </linearGradient>
              </defs>
              <rect x="10" y="10" width="80" height="80" rx="20" fill="url(#wbcGradDarkSignup)"/>
              <path d="M 31 32 H 69 C 72 32 75 35 75 38 V 58 C 75 61 72 64 69 64 H 44 L 33 72 V 64 H 31 C 28 64 25 61 25 58 V 38 C 25 35 28 32 31 32 Z" fill="#ffffff"/>
              <path d="M 35 42 L 44 58 L 50 48 L 56 58 L 65 42" stroke="#2563eb" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <text x="108" y="62" font-family="system-ui, -apple-system, sans-serif" font-weight="800" font-size="34" fill="#ffffff" letter-spacing="-0.5">WhiteBoard<tspan fill="#60a5fa">Chat</tspan></text>
            </svg>
            <h2
              class="mt-6 text-3xl font-medium text-left mb-7 text-n-slate-12"
            >
              {{ $t('REGISTER.TRY_WOOT') }}
            </h2>
          </div>
          <SignupForm />
          <div class="px-1 text-sm text-n-slate-12">
            <span>{{ $t('REGISTER.HAVE_AN_ACCOUNT') }} </span>
            <router-link class="text-link text-n-brand" to="/app/login">
              {{ replaceInstallationName($t('LOGIN.TITLE')) }}
            </router-link>
          </div>
        </div>
      </div>
      <Testimonials
        v-if="isAWhiteBoardChatInstance"
        class="flex-1"
        @resize-containers="resizeContainers"
      />
    </div>
    <div
      v-show="isLoading"
      class="flex items-center min-h-screen justify-center w-full h-full"
    >
      <Spinner color-scheme="primary" size="" />
    </div>
  </div>
</template>
